import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 4V2.5H2.5V13.5H11.5V12",
			stroke: "black",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 8L13.5 8",
			stroke: "black",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10L14.0001 7.9999L12 5.99981",
			stroke: "black"
		})
	]
});
export default SvgSignOut;
